import { Grid } from '@mui/material';
import { useSelector } from 'react-redux';

import { RootState } from '../../../store';
import { CorporatesListState, CorporatesState } from '../../../store/actions/corporates';
import NoData from '../../error/nodata';
import CorporateCard from '../card';

const CorporatesList = () => {
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const corporateState: CorporatesListState = useSelector((state: RootState) => state.corporatesPaginated);

    return (
        <Grid container flexWrap={'wrap'} alignContent={'space-between'}>
            {corporateState?.list?.page?.content.map((currentCorporate: CorporatesState) => {
                return <CorporateCard key={currentCorporate?.id} corporateInfo={currentCorporate} userTimeZone={userTimeZone} />;
            })}
            {corporateState?.list?.page?.content?.length === 0 && <NoData />}
        </Grid>
    );
};

export default CorporatesList;
